import React from 'react';
import { testimonials } from '../data/mock';

const StoriesPage = () => {
  return (
    <div className="min-h-screen pt-24 md:pt-32 bg-white">
      {/* Header Section */}
      <section className="container-luxury mb-16 md:mb-24">
        <div className="max-w-2xl">
          <h1 className="section-title text-[#111111] mb-6 animate-fade-in-up">
            Témoignages
          </h1>
          <div className="w-16 h-px bg-[#111111] mb-8 animate-fade-in-up animation-delay-1" />
          <p className="body-text text-[#666666] animate-fade-in-up animation-delay-2">
            Ce que disent ceux qui m'ont fait confiance.
          </p>
        </div>
      </section>

      {/* Testimonials */}
      <section className="container-luxury">
        <div className="space-y-0">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`py-16 md:py-24 border-t border-[#EAEAEA] ${
                index === testimonials.length - 1 ? 'border-b' : ''
              } animate-fade-in-up`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start">
                {/* Number */}
                <div className="lg:col-span-1">
                  <span className="font-serif text-4xl text-[#EAEAEA]">
                    0{index + 1}
                  </span>
                </div>

                {/* Quote */}
                <div className="lg:col-span-8">
                  <p className="quote-text text-[#111111] leading-relaxed">
                    {testimonial.text}
                  </p>
                </div>

                {/* Author */}
                <div className="lg:col-span-3 lg:text-right">
                  <p className="font-serif text-lg text-[#111111] mb-1">
                    {testimonial.name}
                  </p>
                  <p className="caption-text">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Spacer */}
      <div className="h-24 md:h-32" />
    </div>
  );
};

export default StoriesPage;
